import React, { useState, useEffect, useRef } from 'react'
import { X, Plus } from 'lucide-react'

const API = process.env.REACT_APP_BACKEND_URL

// Saisie libre de garanties (tags) + suggestions des libelles deja utilises
export default function GarantiesTagsInput({ value = [], onChange, tenantId, compact, testId = 'garanties-tags' }) {
  const [input, setInput] = useState('')
  const [suggestions, setSuggestions] = useState([])
  const [open, setOpen] = useState(false)
  const wrapRef = useRef(null)

  useEffect(() => {
    const q = tenantId ? `?tenant_id=${tenantId}` : ''
    fetch(`${API}/api/sinistres/garanties-utilisees${q}`)
      .then(r => r.json()).then(d => setSuggestions(d.garanties || [])).catch(() => {})
  }, [tenantId])

  useEffect(() => {
    function onDoc(e) { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', onDoc)
    return () => document.removeEventListener('mousedown', onDoc)
  }, [])

  const lower = value.map(v => v.toLowerCase())
  const filtered = suggestions.filter(s => !lower.includes(s.toLowerCase()) && s.toLowerCase().includes(input.toLowerCase()))
  const canAddFree = input.trim() && !lower.includes(input.trim().toLowerCase()) && !suggestions.some(s => s.toLowerCase() === input.trim().toLowerCase())

  function add(label) {
    const l = label.trim()
    if (!l || lower.includes(l.toLowerCase())) return
    onChange([...value, l])
    setInput('')
    setOpen(false)
  }
  function remove(label) { onChange(value.filter(v => v !== label)) }

  function onKeyDown(e) {
    if (e.key === 'Enter') { e.preventDefault(); if (input.trim()) add(filtered[0] && filtered[0].toLowerCase() === input.trim().toLowerCase() ? filtered[0] : input) }
    if (e.key === 'Backspace' && !input && value.length) remove(value[value.length - 1])
    if (e.key === 'Escape') setOpen(false)
  }

  return (
    <div ref={wrapRef} className="relative" data-testid={testId}>
      <div className={`flex flex-wrap items-center gap-1.5 border border-slate-200 rounded-lg bg-white focus-within:ring-2 focus-within:ring-indigo-500 ${compact ? 'px-2 py-1 min-h-[32px]' : 'px-2.5 py-1.5 min-h-[38px]'}`}>
        {value.map(v => (
          <span key={v} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium bg-indigo-100 text-indigo-700 border border-indigo-200" data-testid={`garantie-tag-${v}`}>
            {v}
            <button type="button" onClick={() => remove(v)} className="hover:text-red-600" aria-label={`Retirer ${v}`}><X size={10} /></button>
          </span>
        ))}
        <input
          type="text" value={input}
          onChange={e => { setInput(e.target.value); setOpen(true) }}
          onFocus={() => setOpen(true)}
          onKeyDown={onKeyDown}
          placeholder={value.length ? '' : 'DTA, RC Corporel, Marchandises...'}
          className="flex-1 min-w-[120px] text-sm outline-none bg-transparent py-0.5"
          data-testid={`${testId}-input`}
        />
      </div>
      {open && (filtered.length > 0 || canAddFree) && (
        <div className="absolute z-50 top-full left-0 right-0 mt-1 bg-white border rounded-lg shadow-lg max-h-44 overflow-y-auto">
          {filtered.slice(0, 12).map(s => (
            <button key={s} type="button" onMouseDown={e => e.preventDefault()} onClick={() => add(s)}
              className="w-full text-left px-3 py-1.5 text-sm hover:bg-indigo-50" data-testid={`garantie-suggestion-${s}`}>{s}</button>
          ))}
          {canAddFree && (
            <button type="button" onMouseDown={e => e.preventDefault()} onClick={() => add(input)}
              className="w-full text-left px-3 py-1.5 text-xs text-indigo-600 hover:bg-indigo-50 border-t flex items-center gap-1" data-testid="garantie-add-libre">
              <Plus size={12} /> Ajouter « {input.trim()} »
            </button>
          )}
        </div>
      )}
    </div>
  )
}
